"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const typesafe_actions_1 = require("typesafe-actions");
exports.clearCanvas = typesafe_actions_1.createAction('@canvas/clearCanvas')();
exports.drawStroke = typesafe_actions_1.createAction('@canvas/drawStrokeAction')();
